export enum LicenseStorageItemCode {
  ProjectSourceFiles = 'Project Source Files',
  Tasks = 'Tasks',
  ProjectBuilds = 'Project Builds',
  Miscellaneous = 'Miscellaneous'
}
